import type {
  DistributorSettings,
  DrugExpiryDateSettings,
  PaymentType,
  SearchSettings,
} from '@/api/domains/settings.types';
import { httpClient } from '@/shared/lib/axios';

export type DistributorsSettingsParams = {
  region_ids?: string[];
  delivery_region_ids?: string[];
};

export type DistributorSettingsParams = {
  distributor_id: number;
};

export type DistributorSettingsFormData = {
  distributor_id: number;
  personal_discount: number;
  is_active: boolean;
  loyalty_percent?: number;
  payment_types?: string[];
};

export type ExpirationDatesSettingsFormData = {
  warning: ExpirationDatesSettingsFormDataItem;
  danger: ExpirationDatesSettingsFormDataItem;
};

export type ExpirationDatesSettingsFormDataItem = {
  is_active: boolean;
  days: number;
};

export const SettingsApi = {
  fetchDistributorsSettings: async (params?: DistributorsSettingsParams) => {
    const { data } = await httpClient.get<DistributorSettings[]>('settings/distributors', {
      params,
    });

    return data;
  },

  fetchDistributorSettings: async (params: DistributorSettingsParams) => {
    const { data } = await httpClient.get<DistributorSettings>(`settings/distributors/${params.distributor_id}`);

    return data;
  },

  updateDistributorSettingsById: async (distributorId: number, formData: DistributorSettingsFormData) => {
    await httpClient.patch(`settings/distributors/${distributorId}`, formData);
  },

  updateDistributorSettings: async (formData: DistributorSettingsFormData[]) => {
    await httpClient.put('settings/distributors', { items: formData });
  },

  fetchDrugExpiryDateSettings: async () => {
    const { data } = await httpClient.get<DrugExpiryDateSettings>('settings/expire-date');

    return data;
  },

  updateExpirationDatesSettings: async (formData: ExpirationDatesSettingsFormData) => {
    await httpClient.put('settings/expire-date', formData);
  },

  fetchSearchSettings: async () => {
    const { data } = await httpClient.get<SearchSettings>('contractor/settings');

    return data;
  },

  updateSearchSettings: async (formData: SearchSettings) => {
    const { data } = await httpClient.post<SearchSettings>('contractor/settings', formData);

    return data;
  },

  fetchPaymentTypesSettings: async () => {
    const { data } = await httpClient.get<PaymentType[]>('settings/payment-options');

    return data;
  },
};
